import React from 'react';

/** Layered harbor water: sky, open water, deep navy. `to` = next section background. */
export function Waves({
  to = '#FFFFFF',
  className = ''
}: {
  to?: string;
  className?: string;
}) {
  return <svg aria-hidden="true" viewBox="0 0 1440 160" preserveAspectRatio="none" className={`block h-[80px] w-full sm:h-[130px] ${className}`} data-id="element-322" data-mp="ohvvy5qr5e77">
      <path d="M0 90 C 200 30, 380 140, 620 80 S 1040 20, 1440 70 L1440 160 L0 160Z" fill="#9CC4E6" data-id="element-323" data-mp="xi28npemma5b" />
      <path d="M0 110 C 240 60, 420 150, 700 105 S 1120 60, 1440 100 L1440 160 L0 160Z" fill="#1D63A8" data-id="element-324" data-mp="sizfp3bx7udp" />
      <path d="M0 128 C 260 98, 520 160, 800 126 S 1200 102, 1440 122 L1440 160 L0 160Z" fill="#0F2D5C" data-id="element-325" data-mp="17g8c4bg2zoca" />
      <path d="M0 146 C 300 130, 600 160, 900 144 S 1260 136, 1440 144 L1440 160 L0 160Z" fill={to} data-id="element-326" data-mp="12hewodh8hn9h" />
    </svg>;
}